import React, { useRef } from 'react';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box';
import { withProductReview } from '@catalogo/service-americanas-product-review/src/hocs/withProductReview';
import { ContextProvider } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { ErrorBoundary } from '@catalogo/ui-americanas-desktop-product-review/src/helpers';
import { Loading } from '@catalogo/ui-americanas-desktop-product-review/src/components';
import { Header, Reviews } from '../organisms';
import { ReviewContainer } from './Styled';

const Review: React.FC = (props: any) => {
  const { title, loading, dispatchMetrics } = props;
  const ref = useRef(null);

  const content = (
    <ContextProvider value={props}>
      <Header dispatchMetrics={dispatchMetrics} />
      <Reviews dispatchMetrics={dispatchMetrics} />
    </ContextProvider>
  );

  const children = loading ? <Loading fullPage /> : content;

  return (
    <ErrorBoundary>
      <ReviewContainer id="card-reviews-title">
        <AccordionBox
          id="card-reviews-title-accordion"
          ref={ref}
          title={title}
          shouldGetElementHeightOnRender={false}
          visibilityOnInit={true}
          metricId="review"
          anchorRef="#card-reviews-title"
        >
          {children}
        </AccordionBox>
      </ReviewContainer>
    </ErrorBoundary>
  );
};

Review.defaultProps = {
  title: 'Avaliações',
};

const ProductReview = withProductReview(Review);

export default ProductReview;
export { ProductReview };
